import React from 'react';
import {array, func, any, string} from 'prop-types'
import Image from './Image';

const List = ({
    items,
    value,
    imageLoader,
    className,

    /* handlers */
    onChange,
    onFabricInfoClicked,
    onFabricHoverIn,
    onFabricHoverOut,
}) => {

    return (
        <div className={className}>
            {items.map((item) => (
                <Image
                    key={`${item.article}`}
                    onChange={onChange}
                    onFabricInfoClicked={() => onFabricInfoClicked(item)}
                    onFabricHoverIn={() => onFabricHoverIn(item)}
                    onFabricHoverOut={() => onFabricHoverOut(false)}
                    checked={value.article == item.article}
                    src={imageLoader(item.article || item.attrValue)}
                    article={item.displayName}
                    value={item.article}
                />
            ))}
        </div>
    );
};

List.propTypes = {
    items: array,
    value: any,
    className: string,

    /* handlers */
    imageLoader: func,
    onChange: func,
    onFabricInfoClicked: func,
    onFabricHoverIn: func,
    onFabricHoverOut: func,
}

export default List;